<!DOCTYPE html>
<div class="no-thanks-popup">
  @if (isLoadingPopup) {
    <div class="no-thanks-loader">
      <div class="no-thanks-loader__spinner" aria-hidden="true"></div>
    </div>
  } @else if(noThanksDetails?.variant === 1) {
    <section
      class="offer-modal"
      [style.--actual-price-color]="actualPriceColour"
      [style.--cta-color]="ctaColour"
      [attr.aria-labelledby]="showVariant1Title ? 'offer-title' : null"
    >
      <div class="offer-modal__confetti" aria-hidden="true"></div>

      @if (hasValidLogoUrl) {
        <header class="offer-modal__topbar">
          <div class="brand-lockup">
            <img
              class="brand-lockup__logo"
              [src]="noThanksDetails?.logo_url"
              alt=""
              (error)="onLogoLoadError()"
            >
            <p class="brand-lockup__eyebrow">{{ "no-thanks-popup.exclusive" | translate }}</p>
          </div>
        </header>
      }

      @if (showRedRibbon) {
        <aside class="offer-ribbon" aria-label="Discount banner">
          <span class="offer-ribbon__text">{{ redRibbonText }}</span>
        </aside>
      }

      @if (hasValidMainImageUrl) {
        <div class="offer-modal__hero" aria-hidden="true">
          <div class="offer-modal__burst"></div>
          <img
            class="offer-modal__ball"
            [src]="noThanksDetails?.main_image_url"
            alt=""
            (error)="onMainImageLoadError()"
          >
        </div>
      }

      <div class="offer-content">
        <header class="offer-copy">
          @if (showVariant1Title) {
            <h1 id="offer-title" class="offer-copy__title">{{ variant1Title }}</h1>
          }

          @if (showBulletSection) {
            <ul class="offer-benefits">
              @for (bullet of variant1BulletPoints; track $index) {
                <li class="offer-benefits__item">{{ bullet }}</li>
              }
            </ul>
          }
        </header>

        <section class="offer-panel" aria-label="Offer details">
          @if (showPriceComparison) {
            <div class="price-comparison" aria-label="Price comparison">
              @if (showFullPrice) {
                <div class="price-block price-block--old">
                  <p class="price-block__amount price-block__amount--old">
                    <s>{{ resolvedFullPrice }}</s>
                  </p>
                  <p class="price-block__label">{{ "no-thanks-popup.Was" | translate }}</p>
                </div>
              }

              @if (showPriceArrow) {
                <div class="price-comparison__arrow" aria-hidden="true">→</div>
              }

              @if (showActualPrice) {
                <div class="price-block price-block--new">
                  <p class="price-block__amount">{{ resolvedActualPrice }}</p>
                  <p class="price-block__label">{{ "no-thanks-popup.today_only" | translate }}</p>
                </div>
              }
            </div>
          }

          @if (resolvedCtaLabel) {
            <button
              class="offer-cta"
              type="submit"
              (click)="back(noThanksDetails?.cta_link)"
            >
              {{ resolvedCtaLabel }}
            </button>
          }

          <p class="offer-panel__meta">{{ "no-thanks-popup.cancel_anytime" | translate }}</p>
        </section>

        @if (showCtaSubstring) {
          <p class="offer-dismiss">
            <a class="offer-dismiss__link" (click)="onCtaSubstringClick()">{{ ctaSubstring }}</a>
          </p>
        }
      </div>
    </section>
  } @else if(noThanksDetails) {
    <div class="modal-wrapper">
      <h1 class="emoji" [hidden]="!noThanksDetails?.title?.[selectedLanguage] && !noThanksDetails?.title?.en">🤔</h1>
      <h2 class="heading" [hidden]="!noThanksDetails?.title?.[selectedLanguage] && !noThanksDetails?.title?.en">
        {{ noThanksDetails?.title?.[selectedLanguage] || noThanksDetails?.title?.en }}
      </h2>

      <h6 class="sub-heading">
        {{ defaultData && noThanksDetails?.description ? (noThanksDetails?.description | translate) : (noThanksDetails?.description) }}
      </h6>

      <ion-row>
        <ion-button expand="block" color="medium" class="capsule-btn" type="submit" (click)="back(noThanksDetails?.cta_link)">
          {{ noThanksDetails?.cta_label && defaultData
            ? (noThanksDetails?.cta_label | translate)
            : (noThanksDetails?.cta_label) }}
        </ion-button>

        <h6 class="decline-text" (click)="close()">
          {{ noThanksDetails?.no_thanks && defaultData
            ? (noThanksDetails?.no_thanks | translate)
            : (noThanksDetails?.no_thanks?.[selectedLanguage] || noThanksDetails?.no_thanks?.en) }}
        </h6>
      </ion-row>
    </div>
  }
</div>
